<div class="flex flex-row items-center justify-between">
  <div class="mr-1 text-sm">Vendor Contract</div>

  <aux-vendor-dropdown
    [showAllOption]="true"
    [vendors]="vendorList || []"
    [formControl]="vendorFormControl"
    (onChange)="vendorChangeFn($event)"
    [loading]="vendorLoading"
  />
</div>
